import { useEffect, useState } from "react";
import "antd/dist/antd.min.css";
import { Modal, Table, Checkbox } from "antd";
import { useSelector, useDispatch } from "react-redux";
import getMenuInfo from "controllers/getMenuInfo";
import axios from "axios";
import { authAction } from "hooks/actions/mainAction";
import { menuAction } from "hooks/actions/etcAction";

const backend = process.env.REACT_APP_BACKEND;

function AssignedMenu() {
  const dispatch = useDispatch();
  const menuGroupList = useSelector((state) => state.etcReducer.allMenuGroup);
  const menuList = useSelector((state) => state.etcReducer.allMenu);
  const assignedMenuList = useSelector(
    (state) => state.etcReducer.assignedMenu
  );

  // redux가 있는데 굳이 state를 사용하는건 redux에 연결되는 불필요한 렌더링을 줄이기 위함
  const [assignedMenu, setAssignedMenu] = useState(assignedMenuList);

  function assignCheck(assignId, menuGroupId, menuId) {
    axios
      .post(`${backend}/admin_menu/assigned_menu`, {
        assignId,
        menuGroupId,
        menuId,
      })
      .then((data) => {
        // dispatch(assignedMenuAction(data.data.data))
        setAssignedMenu(data.data.data);

        // 체크 및 체크해제시마다 sidebar의 메뉴를 바꿔주기 위함
        getMenuInfo
          .userMenu()
          .then((data) => {
            if (data.response && data.response.status === 401) {
              dispatch(authAction(false, null));
            } else {
              dispatch(menuAction(data.userMenuGroupList, data.menuList));
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
        if (err.response.status === 500) {
          Modal.error({
            title: "서버에러",
            content: "DB에 적용하지 못했습니다. 관리자에게 문의하세요.",
          });
        }
      });
  }

  // 컬럼을 만드는 함수
  const columns = menuGroupList.map((ele, idx) => {
    return {
      index: ele.id,
      title: ele.menu_group_name,
      dataIndex: ele.id,
      width : "120px",
      render: (_, record) => (
        <Checkbox
          defaultChecked={record[ele.id] ? true : false}
          checked={record[ele.id] ? true : false}
          onChange={() => {
            assignCheck(_, ele.id, record.menu_id);
          }}
        />
      ),
    };
  });
  columns.unshift({ title: "관리메뉴", dataIndex: "menu_name", width: "150px" });
  columns.push({ title: "", dataIndex: "" });

  // 메뉴리스트(row값이 되는)에 매칭되는 menuGroup키를 부여하는 함수
  const newMenuList = menuList.map((ele, idx) => {
    for (let i = 0; i < menuGroupList.length; i++) {
      ele[menuGroupList[i].id] = null;
    }
    return ele;
  });

  // 뉴메뉴리스트와 메뉴그룹간의 관계를 설정하는 함수
  for (let i = 0; i < assignedMenu.length; i++) {
    for (let n = 0; n < newMenuList.length; n++) {
      if (newMenuList[n].id === assignedMenu[i].Menu_id) {
        newMenuList[n][assignedMenu[i].MenuGroup_id] = assignedMenu[i].id;
        break;
      }
      continue;
    }
  }

  // 최종적으로 테이블에 들어갈 rowDATA를 만드는 함수
  const data = newMenuList.map((ele, idx) => {
    let result = { index: idx, menu_id: ele.id, menu_name: ele.menu_name };
    for (let i = 0; i < menuGroupList.length; i++) {
      result[menuGroupList[i].id] = ele[menuGroupList[i].id];
    }
    return result;
  });

  useEffect(() => {});
  return (
    <div style={{width:"100%", height:"100%", overflow:"auto"}}>
      <Table
        pagination={false}
        dataSource={data}
        columns={columns}
        rowKey="index"
        scroll={{ x: 800, y: "100%" }}
      />
    </div>
  );
}

export default AssignedMenu;
